<template>
  <v-menu
    bottom
    right
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            class="ml-2"
            text
            v-on="{ ...tooltip, ...menu }"
          >
            <img
              v-if="currentLanguageIcon"
              :src="currentLanguageIcon"
            >
            <v-icon v-else>
              $languages
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('switch_language') }}</span>
      </v-tooltip>
    </template>

    <v-list>
      <v-list-item
        v-for="language in languages"
        :key="language.id"
        @click="localeChange({ lang: language.id, login: login } )"
      >
        <v-list-item-avatar
          tile
          size="24"
        >
          <v-img :src="language.flagSrc" />
        </v-list-item-avatar>
        <v-list-item-title>{{ language.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import { call } from 'vuex-pathify'

  export default {
    props: {
      currentLanguage: {
        type: String,
        required: false,
        default: null,
      },
      login: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data () {
      return {
        // https://www.growthbunker.dev/vueflags
        languages: [
          {
            id: 'en',
            title: 'English',
            flagSrc: require('@/assets/gb.svg'),
          },
          {
            id: 'hu',
            title: 'Hungary',
            flagSrc: require('@/assets/hu.svg'),
          },
          {
            id: 'de',
            title: 'German',
            flagSrc: require('@/assets/de.svg'),
          },
          {
            id: 'it',
            title: 'Italian',
            flagSrc: require('@/assets/it.svg'),
          },
          {
            id: 'fr',
            title: 'French',
            flagSrc: require('@/assets/fr.svg'),
          },
          {
            id: 'pl',
            title: 'Polish',
            flagSrc: require('@/assets/pl.svg'),
          },
          {
            id: 'sk',
            title: 'Slovak',
            flagSrc: require('@/assets/sk.svg'),
          },
          {
            id: 'cs',
            title: 'Czech',
            flagSrc: require('@/assets/cs.svg'),
          },
        ],
      }
    },
    computed: {
      currentLanguageIcon () {
        if (!this.currentLanguage || !this.currentLanguage) {
          return null
        }
        return this.languages.filter(x => x.id === this.currentLanguage)[0]
          .flagSrc
      },
    },
    methods: {
      localeChange: call('app/localeChange'),
      changeLanguage (id) {
        this.$router.push(this.switchLocalePath(id))
        this.$emit('languageChanged', id)
      },
    },
  }
</script>

<style lang="scss" scoped></style>
